import { useEffect } from 'react';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import { Outlet, useLocation } from 'react-router-dom';
import routes from '../../config/routes';
import { navigateToExternalLink } from '../../helpers/utls';
import { useLayoutStore } from '../../state/useLayoutStore';
import { useSettingsStore } from '../../state/useSettingsStore';
import Header from './Header';
import Footer from './Footer';

const routesModeModal = Object.values(routes.publicRoutes).reduce<string[]>((acc, i) => {
  if (i.modeModal) acc.push(i.path);
  return acc;
}, []);

const ModeModalHandle = () => {
  const isModeModal = useLayoutStore(s => s.isModeModal);
  const setModeModal = useLayoutStore(s => s.setModeModal);
  const location = useLocation();
  const shouldShowModeModal = routesModeModal.includes(location.pathname);
  useEffect(() => {
    if (shouldShowModeModal !== isModeModal) setModeModal(shouldShowModeModal);
  }, [shouldShowModeModal, isModeModal, setModeModal]);
  return null;
};

const PublicLayout = () => {
  const whatsappNumber = useSettingsStore(s => s.settings.whatsappNumber);
  return (
    <div className="flex flex-col h-full">
      <FloatingWhatsApp
        className="no-print"
        phoneNumber=""
        accountName=""
        onClick={() => navigateToExternalLink(`https://wa.me/${whatsappNumber}`)}
        chatboxHeight={0}
        notification={false}
      />
      <ModeModalHandle />
      <Header />
      <main className="flex-grow overflow-x-hidden">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
